<app-task-completed-note
  #taskCompletedModal
  [currentTask]="app.taskPanel.selectedItem"
></app-task-completed-note>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.app.discardChanges"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="discardChanges()"
  >
</app-modal>
<app-modal
  #deletePostModal
  [modalMessage]="app.text.post.deleteTaskQuestion"
  [modalTitle]="app.text.post.modalTitle"
  (ok)="deleteTask()"
  >
</app-modal>

@if (app.taskPanel.isOpen) {
  <div class="panel">
    <div class="panel-header">
      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-sm btn-close-panel pull-right"
            (click)="app.taskPanel.closePanel()"
            >
            <i class="fa-light fa-arrow-right-to-line"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right p-1">
            @if (this.app.post.hasEditPermission(app.taskPanel.selectedItem)) {
              <button
                class="btn btn-sm btn-clean"
                (click)="deletePostModal.open()"
                [title]="app.text.post.delete"
                >
                <i class="fa fa-trash"></i>&nbsp;
                <span>{{app.text.app.delete}}</span>
              </button>
            }
          </div>
        </div>
      </div>
      <!-- Status of the task -->
      <div class="col-md-12 statusOption">
        <span> --- </span>
        <div class="panel-status badge-color col-md-10 text-center m-1">
          {{ threadStatus }}
        </div>
        <span> --- </span>
      </div>
      <!-- Details of the task -->
      <div class="col-md-12 task-description">
        <div class="description">
          {{ app.field.getLabel(app.fieldId.post.taskDescription) }}
        </div>
        <textarea
          [(ngModel)]="app.taskPanel.selectedItem.taskDescription"
          [disabled]="!app.taskPanel.hasEditPermissionForDescription"
          >
        </textarea>
        @if (app.taskPanel.selectedItem.taskDescription === '') {
          <span
            class="invalidspan"
            >
            <i class="fal fa-exclamation-circle"></i>
          </span>
        }
      </div>
      @for (postField of columns; track postField) {
        <div
      [ngClass]="{
        'taskNote-field-container': postField === app.fieldId.post.taskNote
      }"
          >
          <div class="row">
            @if (postField !== app.fieldId.post.taskNote && postField !== '') {
              <app-field
                [model]="app.taskPanel.selectedItemModel"
                [field]="postField"
                [showLabel]="true"
                [noStriped]="true"
                [panelInput]="true"
                [disabled]="!this.app.post.hasEditPermission(app.taskPanel.selectedItem)"
              ></app-field>
            }
            @if (
              postField === app.fieldId.post.taskNote &&
              app.taskPanel.selectedItem.taskCompleted
              ) {
              <app-field
                [model]="app.taskPanel.selectedItemModel"
                [field]="postField"
                [showLabel]="true"
                [noStriped]="true"
                [panelInput]="true"
                [disabled]="!app.permission.post.hasEditPermissionForTaskNote"
              ></app-field>
            }
          </div>
        </div>
      }
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right m-2">
            @if (hasPermissionToAddAttachment()) {
              <app-attachments-controls
                [id]="app.taskPanel.selectedItem._id"
                type="post"
                >
              </app-attachments-controls>
            }
          </div>
        </div>
      </div>
      <div class="attachments-container pt-2">
        @if (app.unlockedId === null) {
          <app-attachments
            [id]="app.taskPanel.selectedItem._id"
            type="post"
            [editPermission]="app.post.hasEditPermission(app.taskPanel.selectedItem)"
            [files]="app.taskPanel.selectedItem._attachments"
            [filesDetails]="app.taskPanel.selectedItem.attachmentHistory"
            >
          </app-attachments>
        }
      </div>
      <div class="row">
        <div class="row centeredRow mt-5">
          @if (!app.taskPanel.selectedItem.taskCompleted) {
            <div
              class="col-md-6 text-center saveBtn"
              (click)="taskCompletedModal.openModal()"
              [ngClass]="{'disabled': !hasPermissionToClose()}"
              >
              <button class="saveBtn">
                {{ app.text.post.markCompleted }}
              </button>
            </div>
          }
          @if (app.taskPanel.selectedItem.taskCompleted) {
            <div
              class="col-md-6 text-center completedBtn"
          (click)="
            app.taskCompleted.changeTaskCompletion(
              app.customer,
              app.taskPanel.selectedItem
            )
          "
              [ngClass]="{'disabled': !showReopenButton()}"
              >
              <button class="completedBtn">
                {{ app.text.post.completed }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div>
        @if (
          app.taskPanel.selectedItem.taskCompleted &&
          app.taskPanel.selectedItem.completedBy
          ) {
          <div
            class="complete-task"
            >
            <span class="m-1 completedBy">
              <app-user-link
                [name]="app.taskPanel.selectedItem.completedBy"
                [type]="'post'"
              ></app-user-link>
            </span>
            <span class="font-size-12">
              completed this task on
              {{ app.taskPanel.selectedItem.completedAt | date : "yyyy-MM-dd": "UTC" }}
            </span>
          </div>
        }
        <div>
          <app-credits class="credits" type="post" [isCreated]="true">
          </app-credits>
        </div>
        <div>
          <app-credits
          [ngClass]="{
            credits:
              app.taskPanel.selectedItem.create_time !==
              app.taskPanel.selectedItem.update_time
          }"
            type="post"
            [isEdited]="true"
          ></app-credits>
        </div>
      </div>
    </div>
  </div>
}
